import { useEffect, useState } from "react";
import { Modal, View, Text, ScrollView } from "react-native";
import { CheckBox } from "react-native-elements";
import AdminButton from "../AdminButton";
import { ADMIN_COLORS, ADMIN_FONT } from "../../config/theme/adminColors";

const TYPE_LABEL = {
  product: "Produto",
  plan: "Plano",
  course: "Curso",
};

export function CatalogVitrineHeirModal({
  isVisible,
  deletedProductName,
  candidates = [],
  onCancel,
  onConfirm,
  isSubmitting = false,
}) {
  const [selectedId, setSelectedId] = useState(null);

  useEffect(() => {
    if (!isVisible) {
      setSelectedId(null);
      return;
    }
    if (candidates.length === 1) {
      setSelectedId(candidates[0].id);
    }
  }, [isVisible, candidates]);

  return (
    <Modal visible={isVisible} transparent animationType="fade" onRequestClose={onCancel}>
      <View
        style={{
          flex: 1,
          backgroundColor: "rgba(15, 23, 42, 0.45)",
          justifyContent: "center",
          padding: 20,
        }}
      >
        <View
          style={{
            maxWidth: 520,
            width: "100%",
            alignSelf: "center",
            backgroundColor: ADMIN_COLORS.surface,
            borderRadius: 14,
            padding: 20,
            borderWidth: 1,
            borderColor: ADMIN_COLORS.border,
          }}
        >
          <Text
            style={{
              fontFamily: ADMIN_FONT,
              fontSize: 18,
              fontWeight: "700",
              color: ADMIN_COLORS.ink,
              marginBottom: 8,
            }}
          >
            Escolher novo principal da vitrine
          </Text>
          <Text
            style={{
              fontFamily: ADMIN_FONT,
              fontSize: 14,
              color: ADMIN_COLORS.muted,
              marginBottom: 16,
              lineHeight: 20,
            }}
          >
            {deletedProductName
              ? `"${deletedProductName}"`
              : "Este produto"}{" "}
            exibe o card na vitrine para produtos vinculados. Escolha qual equivalente
            herda a capa, a categoria e a ordem antes da exclusão.
          </Text>

          <ScrollView style={{ maxHeight: 220, marginBottom: 16 }} nestedScrollEnabled>
            {candidates.map((item) => (
              <CheckBox
                key={item.id}
                title={`${item.name || "(sem nome)"} — ${TYPE_LABEL[item.type] || item.type}`}
                checked={selectedId === item.id}
                onPress={() => setSelectedId(item.id)}
                checkedIcon="dot-circle-o"
                uncheckedIcon="circle-o"
                containerStyle={{ backgroundColor: "transparent", paddingVertical: 4 }}
                textStyle={{
                  fontFamily: ADMIN_FONT,
                  fontSize: 14,
                  fontWeight: "400",
                  color: ADMIN_COLORS.ink,
                }}
              />
            ))}
          </ScrollView>

          <View style={{ flexDirection: "row", justifyContent: "flex-end", gap: 10 }}>
            <AdminButton title="Cancelar" variant="secondary" onPress={onCancel} disabled={isSubmitting} />
            <AdminButton
              title="Excluir e transferir vitrine"
              variant="danger"
              onPress={() => {
                const heir = candidates.find((item) => item.id === selectedId);
                if (heir) onConfirm(heir);
              }}
              disabled={!selectedId || isSubmitting}
              isLoading={isSubmitting}
            />
          </View>
        </View>
      </View>
    </Modal>
  );
}

export default CatalogVitrineHeirModal;
